<template>
  <v-dialog
    :value="value"
    max-width="560px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card :class="$vuetify.breakpoint.xsOnly ? 'rounded-0' : 'rounded-xl'">
      <v-card-title class="primary white--text py-3 d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-history</v-icon>
        <span class="text-subtitle-1 font-weight-bold">
          Rekisterinumeroiden hakuhistoria
        </span>
        <v-spacer />
        <v-btn icon dark @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <div v-if="history.length === 0" class="text-center pa-6 grey--text">
          <v-icon size="48" color="grey lighten-1">mdi-history</v-icon>
          <div class="mt-2 text-body-2">Ei vielä tallennettuja hakuja.</div>
        </div>

        <v-list v-else two-line dense class="py-0">
          <template v-for="(item, index) in history">
            <v-list-item
              :key="item.regNumber"
              @click="selectPlate(item.regNumber)"
            >
              <v-list-item-avatar color="grey lighten-4">
                <v-icon color="primary">mdi-car</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="font-weight-bold d-flex align-center">
                  <span>{{ item.regNumber }}</span>
                  <v-chip
                    v-if="item.vehicleInfo"
                    x-small
                    class="ml-2 font-weight-regular grey lighten-3"
                  >
                    {{ item.vehicleInfo }}
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle class="caption grey--text">
                  <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                  {{ formatTime(item.timestamp) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action class="d-flex flex-row align-center">
                <v-btn
                  icon
                  small
                  color="grey"
                  title="Poista historiasta"
                  @click.stop="removeItem(item.regNumber)"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
                <v-icon small color="primary" class="ml-1"
                  >mdi-arrow-right</v-icon
                >
              </v-list-item-action>
            </v-list-item>
            <v-divider
              :key="'div-' + index"
              v-if="index < history.length - 1"
            />
          </template>
        </v-list>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-3 d-flex justify-space-between flex-wrap">
        <v-btn
          v-if="history.length > 0"
          text
          color="red darken-2"
          small
          @click="clearAll"
        >
          <v-icon left small>mdi-delete-sweep</v-icon>
          Tyhjennä historia
        </v-btn>
        <v-spacer v-else />
        <v-btn text color="primary" @click="$emit('input', false)">
          Sulje
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";
import {
  getPlateSearchHistory,
  removePlateSearchHistoryItem,
  clearPlateSearchHistory,
} from "@/utils/plateSearchHistory";

export default {
  name: "PlateSearchHistoryDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      history: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.loadHistory();
      }
    },
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    loadHistory() {
      this.history = getPlateSearchHistory();
    },
    formatTime(ts) {
      if (!ts) return "";
      const d = dayjs(ts);
      const now = dayjs();
      if (d.isSame(now, "day")) {
        return `Tänään klo ${d.format("HH:mm")}`;
      } else if (d.isSame(now.subtract(1, "day"), "day")) {
        return `Eilen klo ${d.format("HH:mm")}`;
      }
      return d.format("DD.MM.YYYY HH:mm");
    },
    selectPlate(reg) {
      this.$emit("select", reg);
      this.$emit("input", false);
    },
    removeItem(reg) {
      this.history = removePlateSearchHistoryItem(reg);
    },
    clearAll() {
      clearPlateSearchHistory();
      this.history = [];
    },
  },
};
</script>
